import { render, staticRenderFns } from "./adicionarCupom.vue?vue&type=template&id=2c61ee98"
import script from "./adicionarCupom.ts?vue&type=script&lang=js&external"
export * from "./adicionarCupom.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c61ee98')) {
      api.createRecord('2c61ee98', component.options)
    } else {
      api.reload('2c61ee98', component.options)
    }
    module.hot.accept("./adicionarCupom.vue?vue&type=template&id=2c61ee98", function () {
      api.rerender('2c61ee98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/venda/adicionarCupom.vue"
export default component.exports